var map = {
	"./AmiyaBagchi.jpg": 623,
	"./AmiyaBagchi.png": 624,
	"./ChinmayTumbe.png": 625,
	"./DavidArnold.jpg": 626,
	"./DavidArnold.png": 627,
	"./DouglasHaynes.jpg": 628,
	"./DouglasHaynes.png": 629,
	"./DwijendraTripathi.jpg": 630,
	"./DwijendraTripathi.png": 631,
	"./GeoffreyJones.png": 632,
	"./IndiraChowdhury.jpg": 633,
	"./IndiraChowdhury.png": 634,
	"./JosephSassoon.jpg": 635,
	"./JosephSassoon.png": 636,
	"./MedhaKudaisya.jpg": 637,
	"./MedhaKudaisya.png": 638,
	"./MilanBalaban.png": 639,
	"./PrafullAnubhai.jpg": 640,
	"./PrafullAnubhai.png": 641,
	"./RamachandraGuha.png": 642,
	"./RituBirla.jpg": 643,
	"./RituBirla.png": 644,
	"./RobertPerks.png": 645,
	"./RossBassett.jpg": 646,
	"./RossBassett.png": 647,
	"./SusiePak.png": 648,
	"./SvenBeckert.png": 649,
	"./SvenBeckertOld.png": 650,
	"./TirthankarRoy.jpg": 651,
	"./TirthankarRoy.png": 652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 622;